import { render, staticRenderFns } from "./TextMenu.vue?vue&type=template&id=49679784&scoped=true"
import script from "./TextMenu.vue?vue&type=script&lang=js"
export * from "./TextMenu.vue?vue&type=script&lang=js"
import style0 from "./TextMenu.vue?vue&type=style&index=0&id=49679784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@2.8.8_underscore@1.13.8_vue-t_oz4jpprlle4dra2pgsz5us5kba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49679784",
  null
  
)

export default component.exports